import { component as defineComponent } from 'flightjs'; // eslint-disable-line no-restricted-imports

function FormAddFragmentIdentifier() {
    this.defaultAttrs({
        fragmentIdentifier: '[data-form-add-fragment-identifier]',
    });

    this.after('initialize', function() {
        this.on('submit', this.addFragmentIdentifier);
    });

    this.addFragmentIdentifier = function(e) {
        e.preventDefault();
        location.href = `${location.pathname}?${this.$node.serialize()}#${this.$node.attr(
            'data-form-add-fragment-identifier'
        )}`;
    };
}

export default defineComponent(FormAddFragmentIdentifier);



// WEBPACK FOOTER //
// ./src/js/component_ui/form-add-fragment-identifier.js